import { JBButton } from '@jbhi-fi/lanyard-ui';
import React from 'react';
import { styles } from './ProductCompareButton.css';
import { Checkbox, CheckboxChecked } from '@jbhi-fi/lanyard-ui/components/Icons';
import { useIdPrefix } from '../../IdPrefix';

interface CompareButtonPDPProps {
  isAddedToCompare: boolean;
  handleClick: (e: React.SyntheticEvent) => void;
}

export const CompareButtonPDP = ({ isAddedToCompare, handleClick }: CompareButtonPDPProps) => {
  return (
    <div className={styles.buttonContainer} id={useIdPrefix('compare-cta-container')}>
      <JBButton
        data-testid="checkbox-compare"
        classes={styles.button}
        icon={isAddedToCompare ? <CheckboxChecked width={18} height={18} /> : <Checkbox width={18} height={18} />}
        iconPosition="left"
        fullWidth
        label="Compare"
        type="secondary"
        onClick={e => handleClick(e)}
      />
    </div>
  );
};
